<template>
    <form>
        <div class="row">
            <div class="col-12 form-group">
                <label for="add_credit_card_zip_code" class="form-label">Cep</label>
                <input type="text" class="form-control" v-maska :data-maska="zipcodeMask" id="add_credit_card_zip_code"
                   v-model.trim="zip_code" placeholder="00000-000">
            </div>

            <div class="col-12 form-group">
                <label for="add_credit_card_street" class="form-label">Endereço</label>
                <input type="text" class="form-control" id="add_credit_card_street" v-model.trim="$v.street.$model"
                    placeholder="Av. Paulista">
            </div>
            <div class="col-12 form-group">
                <label for="add_credit_card_address_number" class="form-label">Número</label>
                <input type="text" class="form-control" v-maska :data-maska="numberMask"
                    id="add_credit_card_address_number" v-model.trim="$v.number.$model" placeholder="1000">
            </div>
            <div class="col-8 form-group">
                <label for="add_credit_card_address_city" class="form-label">Cidade</label>
                <input type="text" class="form-control" id="add_credit_card_address_city" v-model.trim="$v.city.$model"
                    placeholder="São Paulo">
            </div>
            <div class="col-4 form-group">
                <label for="add_credit_card_address_state" class="form-label">Estado</label>
                <input type="text" class="form-control" id="add_credit_card_address_state"
                    v-model.trim="$v.state.$model" placeholder="SP">
            </div>
        </div>
    </form>
</template>
<script lang="ts" setup async>
import useToast from '@/composables/useToast';
import { IAddressResponse } from '@/interfaces';
import { addressValidations } from '@/utils/form_validations';
import { numberMask, zipcodeMask } from '@/utils/masks';
import useVuelidate from '@vuelidate/core';
import { computed, ref, watch } from 'vue';

const emit = defineEmits<{
    onChange: [response: IAddressResponse]
}>()

const {toastError} = useToast()
const street = ref("")
const number = ref("")
const zip_code = ref("")
const city = ref("")
const state = ref("")
const country = ref("BR")

const addressForm = computed(() => ({
    street: street.value,
    number: number.value,
    zip_code: zip_code.value,
    city: city.value,
    state: state.value,
    country: country.value
}))

const $v = useVuelidate(addressValidations(), {
    street,
    number,
    zip_code,
    city,
    state,
    country,
})

watch(addressForm, () => {
    $v.value.$touch()
    emit('onChange', {
        address: addressForm.value,
        form: $v.value,
    })
}, { deep: true, immediate: true })

watch(zip_code, () => {
    setTimeout(() => {
        getAddressFromZipCode()
    }, 300);
})


const getAddressFromZipCode = () => {
    const zipCode = zip_code.value.replace('-', '')
    if (zipCode.length == 8) {
        console.log('zip', zipCode)
        fetch(`https://viacep.com.br/ws/${zipCode.replace('-', '')}/json`).then(r => r.json())
            .then(elem => {
                if(elem.erro) {
                    street.value = ''
                    city.value = ''
                    state.value = ''
                    return toastError('Não foi possível encontrar o endereço para este CEP')
                }
                if (elem.logradouro) {
                    street.value = elem.logradouro
                }
                if (elem.localidade) {
                    city.value = elem.localidade
                }
                if (elem.uf) {
                    state.value = elem.uf
                }
            }).catch(r => console.log(r))
    }
}



</script>